/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChinaRankingCategory
 */
export interface ChinaRankingCategory {
    /**
     * 
     * @type {number}
     * @memberof ChinaRankingCategory
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ChinaRankingCategory
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ChinaRankingCategory
     */
    partnerSchoolTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ChinaRankingCategory
     */
    textJa?: string;
    /**
     * 
     * @type {string}
     * @memberof ChinaRankingCategory
     */
    textEn?: string;
}

export function ChinaRankingCategoryFromJSON(json: any): ChinaRankingCategory {
    return ChinaRankingCategoryFromJSONTyped(json, false);
}

export function ChinaRankingCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChinaRankingCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'partnerSchoolTypeId': !exists(json, 'partnerSchoolTypeId') ? undefined : json['partnerSchoolTypeId'],
        'textJa': !exists(json, 'textJa') ? undefined : json['textJa'],
        'textEn': !exists(json, 'textEn') ? undefined : json['textEn'],
    };
}

export function ChinaRankingCategoryToJSON(value?: ChinaRankingCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'partnerSchoolTypeId': value.partnerSchoolTypeId,
        'textJa': value.textJa,
        'textEn': value.textEn,
    };
}

